<template>
<div>
  <h4>Płatności</h4>
  
  <div class="row" style="margin-bottom: 20px;">
    <div class="col-md-4">
      <input type="text" v-model="search" placeholder="Wyszukaj email..." class="form-control" autofocus>
    </div>
  </div>

  <table class="table table-striped table-hover table-bordered">
    <thead>
    <tr>
      <th>Data płatności</th>
      <th>Pakiet</th>
      <th>Email</th>
      <th>Telefon</th>
      <th>Forma płatności</th>
      <th>Zapłacono</th>
      <th></th>
    </tr>
    </thead>
    <tbody>
    <tr v-for="payment in payments">
      <td>{{ payment.createdAt|date }}</td>
      <td>
        {{ payment.order.planDefinition.name }} <br>
        na {{ payment.order.periodForHuman }}
      </td>
      <td>{{ payment.order.user.email }}</td>
      <td>{{ payment.order.user.phone }}</td>
      <td>{{ payment.order.paymentMethod.name }}</td>
      <td><payment-state :state="payment.order.state"></payment-state></td>
      <td>
        <question-button
          v-if="payment.order.state !== 'realized'"
          @click="setAsPaid(payment)"
          class="btn btn-default"
          question="Czy na pewno oznaczyć opłacenie i zrealizować zamówienie?"
        >
          Oznacz opłacenie
        </question-button>
      </td>
    </tr>
    </tbody>
  </table>
</div>
</template>
<script>
import Api from './../api'
import Flash from './../Flash'
import QuestionButton from './QuestionButton.vue'
import PaymentState from './PaymentState.vue'
import debounce from 'tiny-debounce'

export default {
  data () {
    return {
      search: '',
      payments: []
    }
  },
  components: {
    QuestionButton,
    PaymentState
  },
  methods: {
    fetchData (search) {
      Api.payment.getList(search).then(this.onGetListSuccess)
    },
    onGetListSuccess ({body}) {
      this.payments = body
    },
    setAsPaid (payment) {
      Api.payment.setAsPaid(payment.id).then(this.onSetAsPaidSuccess, this.onSetAsPaidError)
    },
    onSetAsPaidSuccess ({body}) {
      const payment = this.payments.find(p => p.id === body.id)
      const idx = this.payments.indexOf(payment)
      this.$set(this.payments, idx, body)
      Flash.success('Oznaczono opłacenie i zrealizowano zamówienie')
    },
    onSetAsPaidError () {
      Flash.error('Wystąpił błąd podczas oznaczenia opłacenia')
    },
    debounceSearch: debounce(function (value) {
      this.fetchData(value)
    }, 500)
  },
  watch: {
    '$route': 'fetchData',
    'search': 'debounceSearch'
  },
  created () {
    this.fetchData()
  }
}
</script>



// WEBPACK FOOTER //
// Payments.vue?dc363c68